import {
  COMPLETE_APP_ONBOARDING_STEP,
  SKIP_APP_ONBOARDING_STEP,
  FETCH_APP_ONBOARDING,
  POLL_APP_ONBOARDING_PROGRESS,
  SHOW_APP_ONBOARDING_COMPLETION_MODAL,
  HIDE_APP_ONBOARDING_COMPLETION_MODAL,
  UPDATE_DISCOUNT_MODAL_SHOWN,
  UPDATE_DISCOUNT_USED_STATUS,
  FETCH_ONBOARDING_FEATURES,
  DISMISS_ONBOARDING_FEATURE,
} from "../../modules/constants";

export const fetchAppOnboarding = organizationId => ({
  type: FETCH_APP_ONBOARDING,
  payload: { organizationId },
});

export const getOnboardingFeatures = organizationId => ({
  type: FETCH_ONBOARDING_FEATURES,
  payload: { organizationId },
});

export const completeAppOnboardingStep = (organizationId, stepId, options = {}) => ({
  type: COMPLETE_APP_ONBOARDING_STEP,
  payload: { organizationId, stepId, ...options },
});

export const skipAppOnboardingStep = (organizationId, stepId, options = {}) => ({
  type: SKIP_APP_ONBOARDING_STEP,
  payload: { organizationId, stepId, ...options },
});

export const pollAppOnboardingProgress = organizationId => ({
  type: POLL_APP_ONBOARDING_PROGRESS,
  payload: { organizationId },
});

export const showCompletionModal = () => ({
  type: SHOW_APP_ONBOARDING_COMPLETION_MODAL,
});

export const hideCompletionModal = () => ({
  type: HIDE_APP_ONBOARDING_COMPLETION_MODAL,
});

export const updateDiscountModalShown = organizationId => ({
  type: UPDATE_DISCOUNT_MODAL_SHOWN,
  payload: { organizationId },
});

export const updateDiscountUsedStatus = (organizationId, discountUsed) => ({
  type: UPDATE_DISCOUNT_USED_STATUS,
  payload: { organizationId, discountUsed },
});

export const dismissOnboardingFeature = (organizationId, featureName) => ({
  type: DISMISS_ONBOARDING_FEATURE,
  payload: { organizationId, featureName },
});
